import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { jsx as _jsx } from "react/jsx-runtime";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { idFromPrefix } from '@@client/lib/forms';
import FormField from '@@client/components/FormField';
export default function FormTextArea(_ref) {
  var _ref$id = _ref.id,
      id = _ref$id === void 0 ? null : _ref$id,
      idPrefix = _ref.idPrefix,
      onChange = _ref.onChange,
      value = _ref.value,
      name = _ref.name,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      required = _ref.required,
      formFieldAtts = _objectWithoutProperties(_ref, ["id", "idPrefix", "onChange", "value", "name", "disabled", "required"]);

  id = id || idFromPrefix(idPrefix, name);
  value = value === null || value === undefined ? '' : value;
  var errorId = id + '--error';
  return /*#__PURE__*/_jsx(FormField, _objectSpread(_objectSpread({
    errorId: errorId,
    inputId: id
  }, formFieldAtts), {}, {
    children: /*#__PURE__*/_jsx("textarea", {
      id: id,
      name: name,
      onChange: onChange,
      value: value,
      disabled: disabled ? 'disabled' : '',
      "aria-describedby": errorId,
      required: required
    })
  }));
}